<div
  [ngSwitch]="element.type"
  class="cosmos-element-preview__wrapper"
>
    <cosmos-instagram-element-preview
      *ngSwitchCase="'INSTAGRAM'"
      [element]="element"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-instagram-element-preview>
    <cosmos-spotify-element-preview
      *ngSwitchCase="'SPOTIFY'"
      [element]="element"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-spotify-element-preview>
    <cosmos-website-element-preview
      *ngSwitchCase="'WEBSITE'"
      [element]="element"
      [isCompact]="isCompact"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-website-element-preview>
    <cosmos-movie-element-preview
      *ngSwitchCase="'MOVIE'"
      [element]="element"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-movie-element-preview>
    <cosmos-pinterest-element-preview
      *ngSwitchCase="'PINTEREST'"
      [element]="element"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-pinterest-element-preview>
    <cosmos-twitter-element-preview
      *ngSwitchCase="'TWITTER'"
      [element]="element"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-twitter-element-preview>
    <cosmos-youtube-element-preview
      *ngSwitchCase="'YOUTUBE'"
      [element]="element"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-youtube-element-preview>
    <cosmos-default-element-preview
      *ngSwitchDefault
      [element]="element"
      [isCompact]="isCompact"
      class="cosmos-element-preview__wrapper__element"
    ></cosmos-default-element-preview>
</div>
